export default {
  USD: 'green',
  YEN: 'cornflower-blue',
  GBP: 'purple',
};
